import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 md:py-32 bg-soft-white border-t border-stone/30" data-id="element-10">
      <div className="max-w-2xl mx-auto px-6 md:px-12" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-12">
          <div className="text-center mb-12" data-id="element-13">
            <span className="text-xs uppercase tracking-[0.2em] text-warm-gray" data-id="element-14">
              About
            </span>
          </div>

          <div className="space-y-8 font-sans text-charcoal leading-relaxed text-lg" data-id="element-15">
            <p data-id="element-16">
              <span className="font-serif text-xl italic mr-1" data-id="element-17">
                We started Yearn
              </span>{' '}
              because we missed the feeling of waiting for something. In a
              digital world, everything is immediate. We wanted to create
              something that required patience.
            </p>
            <p data-id="element-18">
              Every letter is written by hand — not generated, not templated.
              Each one is a small act of attention in a world that moves too
              fast. We use real ink, real paper, and real stamps.
            </p>
            <p data-id="element-19">
              We believe that the most romantic thing you can do for someone is
              take your time. Yearn is our way of slowing down time, one letter
              at a month.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}